import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import 'bootstrap/scss/bootstrap.scss'
import { ThemeProvider } from "@material-ui/core/styles"
import theme from "./libs/theme"
import CssBaseline from "@material-ui/core/CssBaseline"


ReactDOM.render(


  
 
      // <React.StrictMode>
      <ThemeProvider theme={theme}>
        <BrowserRouter>

        <CssBaseline />
          <App />
     
        </BrowserRouter>
        </ThemeProvider>
      // </React.StrictMode>

  ,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
